module.exports = __webpack_public_path__ + "static/media/icon_anunciate_contenido-calidad.6ee296a1.svg";